<template>
  <div class="w-full h-full space-y-4">
    <Card>
      <CardHeader>
        <CardTitle>Settlements history</CardTitle>
        <CardDescription>View previous cashback settlements</CardDescription>
      </CardHeader>
      <CardContent>
        <DataTable
          :headers="headersTable1"
          :items="historicData"
          :loading="loading"
          v-model:server-options="serverOptions"
          :server-items-length="serverItemsLength"
          :error="error"
          @retry="getHistoricPayouts(serverOptions.page - 1, serverOptions.rowsPerPage)"
        >
          <template #item-action="historicData">
            <div class="flex justify-end items-center gap-1">
              <Button variant="outline" size="sm" @click="download(historicData.id)">
                <FileDown class="w-4 h-4" />Download CSV
              </Button>
            </div>
          </template>
          <template #item-startDate="historicData">
            <span class="text-sm text-muted-foreground whitespace-nowrap">{{ niceDateTime(historicData.startDate) }}</span>
          </template>
          <template #item-endDate="historicData">
            <span class="text-sm text-muted-foreground whitespace-nowrap">{{ niceDateTime(historicData.endDate) }}</span>
          </template>
          <template #item-paid="historicData">
            <Badge v-if="historicData.paid" variant="success">Paid</Badge>
            <Badge v-else variant="warning">Pending</Badge>
          </template>
          <template #item-amount="historicData">
            <span class="text-sm tabular-nums whitespace-nowrap">£{{ historicData.amount.toFixed(2) }}</span>
          </template>
        </DataTable>
      </CardContent>
    </Card>
  </div>
</template>

<script setup></script>

<script>
import { DateTime } from 'luxon'
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  Button,
  Badge,
} from '@boogi/ui'
import { FileDown } from 'lucide-vue-next'
import { DataTable } from '@boogi/ui'

export default {
  name: 'view-payouts',
  components: {
    DataTable,
    Card,
    CardHeader,
    CardTitle,
    CardDescription,
    CardContent,
    Button,
    Badge,
    FileDown,
  },
  props: {},

  data() {
    return {
      historicData: [],
      serverOptions: {
        page: 1,
        rowsPerPage: 25,
      },
      serverItemsLength: undefined,
      showErrorModal: false,
      showSuccessModal: false,
      showFormModal: false,
      loading: true,
      error: false,
      headersTable1: [
        { text: 'Start date', value: 'startDate' },
        { text: 'End date', value: 'endDate' },
        { text: 'Paid', value: 'paid' },
        { text: 'Value', value: 'amount' },
        { text: 'Action', value: 'action' },
      ],
      apiKeys: [],
    }
  },
  created() {
    this.getHistoricPayouts(0, 25)
  },
  methods: {
    niceDateTime(dateObject) {
      return DateTime.fromMillis(dateObject).toLocaleString(DateTime.MED)
    },

    async download(id) {
      try {
        const token = localStorage.getItem('token')
        const apiUrl = localStorage.getItem('apiUrl') || process.env.VUE_APP_API_URL

        this.loading = true

        const response = await this.$apiFetch(
          `${apiUrl}/private/api/client/payout/historic/${id}/csv`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `${token}`,
            },
          }
        )

        if (response.ok) {
          const blob = await response.blob() // Convert the response to a blob
          const url = window.URL.createObjectURL(blob) // Create a URL for the blob

          // Create a link element and set its href to the blob URL
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `payout_historic_${id}.csv`) // Set the desired file name

          document.body.appendChild(link)
          link.click() // Programmatically click the link to trigger download

          document.body.removeChild(link) // Remove the link after the download is triggered
        } else {
          console.error('Failed to download CSV')
        }
      } catch (error) {
        console.error('Error downloading CSV:', error)
      } finally {
        this.loading = false // Stop loading
      }
    },

    async getHistoricPayouts(page, size) {
      const token = localStorage.getItem('token')
      const apiUrl = localStorage.getItem('apiUrl') || process.env.VUE_APP_API_URL

      this.loading = true
      this.error = false

      try {
        const response = await this.$apiFetch(
          `${apiUrl}/private/api/client/payout/historic?page=${page}&size=${size}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `${token}`,
            },
          }
        )

        if (response.ok) {
          var object = await response.json()
          this.historicData = object.content
          this.serverItemsLength = object.totalElements
        } else {
          this.error = true
        }
      } catch (e) {
        this.error = true
      } finally {
        this.loading = false
      }
    },
  },
  computed: {},
  mounted() {
    document.title = 'Dashboard | Payouts'
  },
  watch: {
    serverOptions: {
      deep: true,
      handler(val) {
        this.getHistoricPayouts(val.page - 1, val.rowsPerPage)
      },
    },
  },
}
</script>
